import { useEffect } from 'react'
import { updateCustomer } from '../../../../client/api/cart'
import { useCustomerAuth } from '../../../../client/auth/CustomerAuthContext'

interface UseCustomerAuthCartProps {
  cartGuid?: string
}

export const useCustomerAuthCart = ({ cartGuid }: UseCustomerAuthCartProps) => {
  const { customer } = useCustomerAuth()

  // Sync customer data with cart when both are available
  useEffect(() => {
    if (cartGuid && customer) {
      updateCustomer(cartGuid, {
        email: customer?.email ?? '',
        firstName: customer?.firstName ?? '',
        lastName: customer?.lastName ?? '',
        phone: customer?.phone ?? ''
      }).catch(() => {
        // if the cart has invalid items, this will fail
        // we don't have access to cart contents here so easier to just swallow
        // this since the customer will get updated later anyway
      })
    }
  }, [cartGuid, customer])
}
